import './pure.css';
import './app.scss';
import './app-forms.scss';
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import classNames from 'classnames';
import { isLoading } from '../js/initialFetch';
import { stripTrailingSlash } from '../js/utils';
import { imageStatuses } from '../js/statuses';
import appMode from '../js/appMode';
import { hasValidLicence } from '../js/projections/licence';
import DashboardGrayIcon from '../icons/clone-icons_dashboard-gray.svg';
import NewImageGrayIcon from '../icons/clone-icons_newimage-gray.svg';
import NewCloneGrayIcon from '../icons/clone-icons_newclone-gray.svg';
import SettingsGrayIcon from '../icons/clone-icons_settings-gray.svg';
import RedgateLogo from '../icons/redgate.svg';
import TopNotificationBar from './common/TopNotificationBar';
import DisableableLink from './common/DisableableLink';
import LoaderWithText from './common/LoaderWithText';
import ManagePageLayout from './common/PageLayout/Manage';

const navSection = {
    home: 'home',
    dashboard: 'dashboard',
    createImage: 'createImage',
    createClone: 'createClone',
    settings: 'settings'
};

const Sidebar = ({ mode, children }) => {
    const isInManageMode = mode === appMode.manage;
    const isInDoingMode = mode === appMode.doing;
    const isInSettingMode = mode === appMode.setting;
    const sidebarClassNames = classNames('sidebar', { 'in-doing-mode': isInDoingMode }, { 'in-manage-mode': isInManageMode }, { 'in-setting-mode': isInSettingMode });

    return <div className={sidebarClassNames}>
        {children}
    </div>;
};

const SidebarButton = ({ active, title, link, icon, collapsed, disabled }) => {
    return <li className={classNames({ 'active': active })} title={collapsed ? title : null}>
        <DisableableLink to={link} disabled={disabled}>
            <img src={icon} alt={collapsed ? title : null}></img>
            {!collapsed && <span>{title}</span>}
        </DisableableLink>
    </li>;
};

SidebarButton.propTypes = {
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
    collapsed: PropTypes.bool,
    disabled: PropTypes.bool
};

const App = React.createClass({
    propTypes: {
        location: PropTypes.object.isRequired,
        mode: PropTypes.string.isRequired,
        hasImage: PropTypes.bool.isRequired,
        shouldShowGettingStarted: PropTypes.bool.isRequired,
        canCreate: PropTypes.bool.isRequired
    },
    renderHeader() {
        return (
            <div className="app-header">
                <TopNotificationBar />

                <div className="inner">
                    <Link to="/" className="Layout-icon"></Link>
                    <div className="redgate-logo">
                        <img src={RedgateLogo}></img>
                    </div>
                    <div className="header-links">
                        <a target="_parent" href="http://www.red-gate.com/products/dba/sql-clone/#contact" className="header-links-sales">Contact sales</a>
                        <a target="_blank" href="http://www.red-gate.com/products/dba/sql-clone/" className="button button--primary spaced-left--tight button--small">Download free trial</a>
                    </div>
                </div>
            </div>
        );
    },
    renderNavigation: function (hasImage) {
        const currentPath = this.props.location.pathname;
        const selectedNav = stripTrailingSlash(currentPath.toLowerCase()).startsWith('/images/create') ? navSection.createImage
            : stripTrailingSlash(currentPath.toLowerCase()).startsWith('/clones/create') ? navSection.createClone
                : stripTrailingSlash(currentPath.toLowerCase()).startsWith('/dashboard') ? navSection.dashboard
                    : stripTrailingSlash(currentPath.toLowerCase()).startsWith('/settings') ? navSection.settings : navSection.home;
        const { mode, canCreate } = this.props;
        const isInDoingMode = mode === appMode.doing;
        const isInSettingMode = mode === appMode.setting;
        const collapsed = isInDoingMode || isInSettingMode;

        return (<nav className="navigation">
            <ul>
                {hasImage && <SidebarButton title="Dashboard" link="/dashboard" icon={DashboardGrayIcon}
                    active={selectedNav === navSection.dashboard} collapsed={collapsed} />}
                <SidebarButton title="Create image" className="imageNav" link="/images/create/setup" icon={NewImageGrayIcon}
                    active={selectedNav === navSection.createImage} collapsed={collapsed} disabled={!canCreate} />
                {hasImage && <SidebarButton title="Create clone" className="cloneNav" link="/clones/create/source" icon={NewCloneGrayIcon}
                    active={selectedNav === navSection.createClone} collapsed={collapsed} disabled={!canCreate} />}
                <SidebarButton title="Settings" link="/settings" icon={SettingsGrayIcon}
                    active={selectedNav === navSection.settings} collapsed={collapsed} />
            </ul>
        </nav>);
    },
    renderError: function (error) {
        return <ManagePageLayout>
            <p className="initial-load-error">Error while loading SQL Clone.</p>
            {error && <p>{error.userMessage}</p>}
        </ManagePageLayout>;
    },
    renderLoading: function () {
        return (
            <div className="initialLoading">
                <LoaderWithText loadingText="Loading" />
            </div>
        );
    },
    render: function () {
        const { mode, hasImage, loaded, notification } = this.props;
        const pageClasses = classNames('Layout-all', `sc-page-mode-${mode}`, { 'has-top-notification': notification });
        const header = this.renderHeader();

        return (

            <div className={pageClasses}>

                <div className="Layout-header">
                    {header}
                </div>

                <div className="Layout-page">
                    <div className="Layout-manager">

                        <Sidebar mode={mode}>
                            {loaded.isLoaded && this.renderNavigation(hasImage)}
                        </Sidebar>

                        <div className="Layout-managerContent">
                            {loaded.isLoaded && this.props.children}
                            {loaded.isFaulted && this.renderError(loaded.error)}
                            {!(loaded.isLoaded || loaded.isFaulted) && this.renderLoading()}
                        </div>

                    </div>
                </div>

            </div>
        );
    }
});

const mapStateToProps = (state) => {
    const hasImage = Array.from(state.images.value.values()).some(i => i.status.state !== imageStatuses.deleted);

    return {
        mode: state.app.mode,
        hasImage: hasImage,
        loaded: isLoading(state),
        notification: state.app.notifications.top,
        shouldShowGettingStarted: state.app.shouldShowGettingStarted,
        canCreate: true,
    };
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.jsx